module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/ekanban-236dfb0ff451eb31552f926fbba73dc9.png";